import * as React from 'react';
import * as styles from './Text.css';
import "../../../styles/BasicIA.css";
import { Controller } from '../controller/Controller';
import { LocalizationService } from '../../../services/LocalizationService';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import { IAEditor } from '../../editor/Index';

export interface IProps {
  store?: Store;
  id: string;
  index: number;
  text: string;
  boxStyle: any;
  hideToolbox: boolean;
  showDropZones: boolean;
  onChange: (text: string) => void;
  onStyleChange: (style: any) => void;
  onFocus: () => void;
  onDrag: () => void;
  onDragEnd: () => void;
}

export interface IState {
  editorHtml: any;
  showController: boolean;
  showDropZones: boolean;
  currentRange?: any;
}

@inject('store')
@observer
export class Text extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      editorHtml: undefined,
      showController: false,
      showDropZones: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    this.setState({
      editorHtml: this.props.text ? this.props.text : ``
    });
    this.hideToolbox();
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.hideToolbox) {
      this.hideToolbox();
    }
    if (this.props.hideToolbox !== props.hideToolbox && props.hideToolbox != undefined && !props.hideToolbox) {
      this.setState({ showController: true });
    }
    if (props.showDropZones) {
      this.hideToolbox()
    }
    if (props.showDropZones !== this.props.showDropZones) {
      setTimeout(() => {
        this.setState({ showDropZones: props.showDropZones });
      }, 0);
    }
  }

  private hideToolbox(): void {
    const editor = document.getElementById(this.props.id);
    const toolbox: any = editor ? editor.getElementsByClassName("ql-toolbar")[0] : undefined;
    if (toolbox) {
      toolbox.style.display = "none";
    }
    this.setState({ showController: false, currentRange: undefined });
    this.props.store.showLinkEditor = false;
    this.props.store.linkEditorTitle = undefined;
    this.props.store.linkEditorTarget = undefined;
    this.props.store.linkEditorUrl = undefined;
    this.props.store.textSelection = undefined;
    this.props.store.linkEditorRange = undefined;
  }

  public render(): JSX.Element {
    return (
      <div
        id={"IA_text"}
        className={styles.IA_text}
      >
        <Controller
          visible={this.state.showController && !this.state.showDropZones}
          highlightColor={this.props.store.highlightColor}
          onDublicate={() => this.props.store.dublicateComponent()}
          onDelete={() => {
            this.props.store.removeComponentAtIndex(this.props.index);
            this.hideToolbox()
            this.props.store.activeComponent = undefined;
            this.forceUpdate();
          }}
          onDrag={() => {
            this.props.onDrag();
          }}
          onDragEnd={() => this.props.onDragEnd()}
        />
        {this.state.showDropZones && this.props.index === 0 && !this.state.showController &&
          <div className={styles.IA_dropZones}
            style={{
              marginBottom: 10
            }}
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDragEnter={(event) => {
              event.preventDefault();
            }}
            onDropCapture={(event) => {
              event.preventDefault();
              if (this.props.store.startIndex != undefined) {
                this.props.store.moveComponentAtIndex(0);
              } else {
                this.props.store.addComponentAtIndex(0);
              }
            }}
          />
        }
        {this.props.store.open &&
          <IAEditor
            useImageAPI
            token={this.props.store.token}
            tenant={this.props.store.tenant}
            environment={this.props.store.environment}
            isMobile={this.props.store.isMobile}
            highlightColor={this.props.store.highlightColor}
            content={this.state.editorHtml}
            placeholder={this.localizationService.strings.Composer_TypeHere}
            boxStyle={this.props.boxStyle}
            fontSlots={this.props.store.fontSlots}
            style={{
              width: "100%",
              minHeight: 116,
              border: this.state.showController ? `2px solid ${this.props.store.highlightColor}` : "1px solid #cbcbcb",
              marginBottom: this.state.showController ? 0 : 2,
              padding: 5,
              boxSizing: "border-box",
              borderRadius: 5,
              float: "left"
            }}
            hideToolbox={!this.state.showController}
            fontSizeSupport
            fontStyleSupport
            listsSupport
            textAlignmentSupport
            textColorSupport
            clearStylingSupport
            emojiSupport
            linkSupport
            boxSupport
            indentSupport
            quoteSupport
            tableSupport
            onChange={(editorHtml) => {
              this.setState({ editorHtml }, () => this.props.onChange(editorHtml));
            }}
            onFocus={() => {
              setTimeout(() => {
                this.setState({ showController: true });
                this.props.onFocus();
              }, 0);
            }}
            onStyleChange={(style) => this.props.onStyleChange(style)}
            uploadImagesToSharepoint
            mentionsSupport
          />
        }
        {this.state.showDropZones && !this.state.showController &&
          <div
            className={styles.IA_dropZones}
            style={{
              marginTop: 10
            }}
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDragEnter={(event) => {
              event.preventDefault();
            }}
            onDropCapture={(event) => {
              event.preventDefault();
              if (this.props.store.startIndex != undefined) {
                this.props.store.moveComponentAtIndex(this.props.index + 1);
              } else {
                this.props.store.addComponentAtIndex(this.props.index + 1);
              }
            }}
          />
        }
      </div>
    );
  }


}